import { useSelector, useDispatch } from "react-redux"
import type { ReduxState } from "model/state"
import type { AppDispatch } from "../../store"

export const useAppSelector = useSelector.withTypes<ReduxState>()
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
